import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client"; // Import createRoot
import { MsalProvider } from "@azure/msal-react";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"; // Import service worker

import { PublicClientApplication } from '@azure/msal-browser';
import { initializeMsal } from "./config/msalInstance";
  
let deferredPrompt:any;
window.addEventListener("beforeinstallprompt", (event) => {
  event.preventDefault();
  deferredPrompt = event;
  console.log("PWA install prompt saved for later", deferredPrompt);
});

window.addEventListener("appinstalled", () => {
  console.log("PWA was installed successfully!");
});

// Handle Install on button click or custom UI
const handleInstall = async () => {
  if (deferredPrompt) {
    deferredPrompt.prompt();
    const choiceResult = await deferredPrompt.userChoice;
    if (choiceResult.outcome === "accepted") {
      console.log("User installed the PWA");
    } else {
      console.log("User dismissed the install prompt");
    }
    deferredPrompt = null;  // Reset the prompt
  }
};

const Root = () => {
  const [msalInstance, setMsalInstance] = useState<PublicClientApplication | null>(null);

  useEffect(() => {
      initializeMsal().then(setMsalInstance);
  }, []);

  if (!msalInstance) {
      return <div>Loading...</div>; // Prevents rendering before initialization
  }

  return (
      <MsalProvider instance={msalInstance}>
          <App />
      </MsalProvider>
  );
};

// Use createRoot instead of ReactDOM.render
const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(<Root />);

 serviceWorkerRegistration.register();
